import React, { useState } from "react";
import { toast } from "react-toastify";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { MdDelete, MdEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import ModalConfirm from "../../molecules/ModalConfirm";
import ModalEditEnterprise from "../clientes/empresas/ModalEditEnterprise";
import useModal from "../../../hooks/useModal";
import { DELETE_ENTERPRISE } from "../../../api/apiEmpresas";

const EmpresaAdminTable = ({ data, loading, clients, refetch }) => {
    const navigate = useNavigate();
    const [empresa, setEmpresa] = useState();
    const { open, close, isOpen } = useModal();
    const { open: openDelete, close: closeDelete, isOpen: isOpenDelete } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);

    const handlePush = (id) => {
        navigate(`/clientes/empresas/${id}`);
    };

    const handleOpenEdit = (empresa) => {
        setEmpresa(empresa);
        open();
    };

    const handleOpenDelete = (empresa) => {
        openDelete();
        setEmpresa(empresa);
    };

    const handleDelete = async () => {
        try {
            await DELETE_ENTERPRISE(empresa.id);
            toast.success("Eliminado correctamente");
            closeDelete();
            refetch();
        } catch (error) {
            console.error(error);
            toast.error("Error al eliminar");
        }
    };

    const columns = [
        { name: "Empresa", cell: row => (
            <div className="flex flex-col">
                <p> {row.name}  </p>
                <p>{row.rfc}</p>
                <p> Cliente: {getClientName(row.userId)} </p>
            </div>
            ),
        },
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p>
                <p> {empresa?.name_rl ? `RL ${empresa.name_rl}` : null} </p>
            </div>
            ),
        },
        { name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
                <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(row.id)} />
            </div>
        )},
    ];

    const columnsResponsive = [
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.name}  </p>
                <p>{row.rfc}</p>
                <p> Cliente: {getClientName(row.userId)} </p>
                <p> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p> 
                <p> {empresa?.name_rl ? `RL ${empresa.name_rl}` : null} </p>
            </div>
            ),
        },
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button
                text={<MdEdit size={22} />}
                bgColor="blue"
                width="w-10"
                onClick={() => handleOpenEdit(data)}
            />
            <Button
                text={<MdDelete size={22} />}
                bgColor="red"
                width="w-10"
                onClick={() => handleOpenDelete(data)}
            />
            <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(data.id)} />
        </div>
    );

    const conditionalRowStyles = [
        {
            when: row => row?.id === expandedRow?.id,
            style: {
                backgroundColor: '#f3f4f6',
            },
        },
    ]; 

    const getClientName = (userId) => {
        if (loading) return "Cargando...";
        const client = clients?.find(a => a.userId === userId);
        return client ? client.name : 'No asignado';
    };

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
            {isOpen &&
                <Modal onClose={close} title="Editar empresa" >
                    <ModalEditEnterprise onClose={close} refetch={refetch} empresa={empresa} />
                </Modal>
            }
            {isOpenDelete &&
                <ModalConfirm onClose={closeDelete} onConfirm={handleDelete} eliminacion />
            }
        </div>
    );
};

export default EmpresaAdminTable;